import React, { useEffect, useState } from 'react';
import classes from "./LiveMatches2.module.css";
import Header2 from '../../component/NewComponents/Header2';
import { liveMatchesApi, upcomingMatchesApi, userMatchesApi } from '../../http/http';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import SmallLoader from '../../component/SmallLoader';
import { removeUserDetails } from '../../store/slices/userSlice';
import { toast } from 'react-toastify';
import MatchLayoutNew from '../../component/NewComponents/MatchLayoutNew';
import MatchLiveLayoutNew from '../../component/NewComponents/MatchLiveLayoutNew';
import { useTranslation } from 'react-i18next';

const LiveMatches2 = () => {
  const [liveMatches, setLiveMatches]       = useState([]);
  const [upcomingMatches, setUpcomingMatches] = useState([]);
  const [userMatches, setUserMatches]         = useState(null);
  const [loader, setLoader]                   = useState(true);
  const [loading, setLoading]                 = useState(true);

  const { userDetails } = useSelector(state => state?.persisted?.userSlice);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {t}=useTranslation();

  const fetchUserMatches = async () => {
    try {
      const response = await userMatchesApi(userDetails?.token);
      setUserMatches({ fantasy: response?.data?.fantasy, prediction: response?.data?.prediction });
    } catch (error) {
      if (error?.response?.status === 403) {
        dispatch(removeUserDetails()); toast.error(t("71")); navigate('/');
      } else {
        toast.error(error?.response?.data?.message || error?.response?.message || t("2"));
      }
    }
  };

  const fetchLiveMatches = async () => {
    try {
      const response = await liveMatchesApi(userDetails?.token);
      setLiveMatches(response?.data);
    } catch (err) { console.log(err); }
  };

  const fetchUpcomingMatches = async () => {
    try {
      const response = await upcomingMatchesApi(userDetails?.token);
      setUpcomingMatches(response?.data);
    } catch (err) { console.log(err); }
  };

  const fetchData = async (load) => {
    if (load) setLoading(true);
    setLoader(true);
    await fetchUserMatches();
    await fetchLiveMatches();
    await fetchUpcomingMatches();
    setLoading(false);
    setLoader(false);
  };

  useEffect(() => { fetchData(true); }, []);

  useEffect(() => {
    if (!loader) {
      const id = setInterval(() => { if (!document.hidden) fetchData(false); }, 10000);
      return () => clearInterval(id);
    }
  }, [loader]);

  return (
    <>
      <Header2 active={2} />

      <div className={classes.page}>
        <div className={classes.bgGlow} />
        <div className={classes.bgGrid} />

        <main className={classes.main}>

          {/* ── Hero bar ── */}
          <div className={classes.heroBar}>
            <div className={classes.heroLeft}>
              <span className={classes.heroEyebrow}>{t("87")} &amp; {t("88")}</span>
              <h1 className={classes.heroTitle}>
                {t("89")} <em>&amp; {t("90")}</em>
              </h1>
            </div>
            <div className={classes.heroRight}>
              {liveMatches.length > 0 && (
                <div className={classes.liveCountTag}>
                  <span className={classes.liveDot} />
                  {liveMatches.length} {t("91")}
                </div>
              )}
              <div className={classes.upcomingCountTag}>
                <span className={classes.upcomingDot} />
                {upcomingMatches.length} {t("92")}
              </div>
            </div>
          </div>

          <div className={classes.heroDivider} />

          {loading ? (
            <div className={classes.loaderWrap}>
              <SmallLoader style={{ border: "4px solid #e60000", borderTopColor: "transparent" }} />
              <p className={classes.loaderText}>{t("93")}</p>
            </div>
          ) : (
            <>
              {/* ── LIVE NOW section ── */}
              <div className={classes.sectionHeader}>
                <div className={classes.sectionDotLive}>
                  <span className={classes.sectionDotInner} />
                </div>
                <span className={classes.sectionTitle}>{t("94")}</span>
                {liveMatches.length > 0 && (
                  <span className={classes.sectionCount}>{liveMatches.length}</span>
                )}
                <div className={classes.sectionLine} />
              </div>

              <div className={classes.matchGrid}>
                {liveMatches.length > 0 ? (
                  liveMatches.map((match, index) => {
                    const match_details = JSON.parse(match?.match_details);
                    return (
                      <MatchLiveLayoutNew
                        match={match}
                        match_details={match_details}
                        key={index}
                        index={index}
                      />
                    );
                  })
                ) : (
                  <div className={classes.emptyState}>
                    <span className={classes.emptyEmoji}>📺</span>
                    <p className={classes.emptyTitle}>{t("95")}</p>
                  <p className={classes.emptySub}>{t("96")}</p>
                  </div>
                )}
              </div>

              {/* ── UPCOMING section ── */}
              <div className={`${classes.sectionHeader} ${classes.sectionHeaderUpcoming}`}>
                <div className={classes.sectionDotUpcoming} />
                <span className={classes.sectionTitle}>{t("97")}</span>
                {upcomingMatches.length > 0 && (
                  <span className={classes.sectionCount}>{upcomingMatches.length}</span>
                )}
                <div className={classes.sectionLine} />
              </div>

              <div className={classes.matchGrid}>
                {upcomingMatches.length > 0 ? (
                  upcomingMatches.map((match, index) => (
                    <MatchLayoutNew
                      match={match}
                      key={index}
                      index={index}
                      fantasy_match_joined={
                        userMatches?.fantasy?.filter(d => d?.match_fixture_id === match?.match_fixture_id).length > 0
                      }
                      prediction_match_joined={
                        userMatches?.prediction?.filter(d => d?.match_fixture_id === match?.match_fixture_id).length > 0
                      }
                    />
                  ))
                ) : (
                  <div className={classes.emptyState}>
                    <span className={classes.emptyEmoji}>⚽</span>
                    <p className={classes.emptyTitle}>{t("98")}</p>
                    <p className={classes.emptySub}>{t("99")}</p>
                  </div>
                )}
              </div>
            </>
          )}
        </main>
      </div>
    </>
  );
};

export default LiveMatches2;